import gql from "graphql-tag";

// Queries
export const GET_BILLING_BY_COMPETENCE_POWERPLANT = gql`
  query billing($power_plant_id: String!, $competence: String!) {
    billing(power_plant_id: $power_plant_id, competence: $competence) {
      competence
      amount
      amount_kW
      total
      transaction {
        cost
        payment_method
      }
      discount
      status
      user {
        name
      }
    }
  }
`;

export const GET_BILLING_TOTAL = gql`
  query billingTotal($power_plant_id: String!, $competence: String!) {
    billingTotal(power_plant_id: $power_plant_id, competence: $competence) {
      valor_conta
      data_leitura_anterior
      data_leitura_atual
      data_leitura_proxima
      dias_leitura
      number_of_customers
      total_clientes
      power_plant_amount
      total_amount_kw
      total_amount_kw
      power_plant_amount
      total_consumo_kW
      last_balance
      current_balance
      total_faturado
      total_fees
      total_pago
      total_pendente
      total_creditos
      total_cartao
      total_boleto
      total_economia
      powerplant {
        name
        owners {
          name
          percentage
        }
      }
    }
  }
`;

export const GET_ALL_BILLING_TOTAL = gql`
  query billingTotals(
    $power_plant_id: String!
    $orderBy: OrderBy
    $count: Int
    $page: Int
    $status: String
  ) {
    billingTotals(
      power_plant_id: $power_plant_id
      orderBy: $orderBy
      count: $count
      page: $page
    ) {
      competence
      number_of_customers
      last_balance
      current_balance
      total_amount_kw
      total_consumo_kW
      total_creditos
      power_plant_amount
      total_consumo_kW
    }
    consumerunits(power_plant_id: $power_plant_id, status: $status) {
      installation_number
      percentage
      status
      user {
        card_default
        boleto_accepted_at
      }
    }
  }
`;

export const GET_BILLING = gql`
  query billing($power_plant_id: String!, $competence: String!) {
    billing(power_plant_id: $power_plant_id, competence: $competence) {
      id
      competence
      amount
      amount_kW
      total
      tarifa
      total_utility_company
      custo_disp
      balance
      customer_id
      referral_balance
      transaction {
        cost
        payment_method
        boleto_barcode
        boleto_expiration_date
        boleto_url
      }
      transactionPagarme {
        id
        cost
        payment_method
        payables {
          fee
        }
        boleto_barcode
        boleto_expiration_date
        boleto_url
      }
      discount
      status
      user {
        name
        phone
      }
    }
    billingTotal(power_plant_id: $power_plant_id, competence: $competence) {
      valor_conta
      data_leitura_anterior
      data_leitura_atual
      data_leitura_proxima
      dias_leitura
      number_of_customers
      total_clientes
      power_plant_amount
      total_amount_kw
      total_amount_kw
      power_plant_amount
      total_consumo_kW
      last_balance
      current_balance
      total_faturado
      total_fees
      total_pago
      total_pendente
      total_creditos
      total_cartao
      total_boleto
      total_economia
      total_custo_disp
      cobraCustoDisp
      powerplant {
        name
        owners {
          name
          percentage
        }
      }
      power_plant_consumption_kW
      total_desconto
      total_nao_faturado
    }
  }
`;

export const GET_BILLING_DETAIL = gql`
  query billing(
    $power_plant_id: String!
    $competence: String!
    $customer_id: String!
  ) {
    billing(
      power_plant_id: $power_plant_id
      competence: $competence
      customer_id: $customer_id
    ) {
      competence
      amount
      total_invoice
      total_utility_company
      total
      amount_kW
      total
      tarifa
      balance
      transaction {
        id
        cost
        payment_method
        status
        boleto_barcode
        boleto_expiration_date
        boleto_url
      }
      transactionPagarme {
        cost
        payment_method
        payables {
          fee
        }
        status
      }
      discount
      status
      user {
        name
        email
      }
    }
  }
`;

export const GET_BILLING_BY_USER = gql`
  query billing($customer_id: String!) {
    billing(
      customer_id: $customer_id
      orderBy: { field: "competence", direction: "desc" }
    ) {
      power_plant_id
      competence
      amount
      total
      discount
      status
      transaction {
        payment_method
      }
    }
  }
`;

export const GET_DETAILBILLING_BY_USER = gql`
  query billing($customer_id: String!) {
    billing(
      customer_id: $customer_id
      orderBy: { field: "competence", direction: "desc" }
    ) {
      competence
      custo_disp
      total_utility_company
      amount
      total_invoice
      total
      discount
      status
      transaction {
        payment_method
        boleto_url
        boleto_barcode
      }
    }
  }
`;

// Mutations
export const SET_BILLING_TOTAL = gql`
  mutation createBillingTotal(
    $competence: String!
    $power_plant_id: String!
    $current_balance: Float
    $last_balance: Float
    $data_leitura_anterior: String
    $data_leitura_atual: String
    $data_leitura_proxima: String
    $dias_leitura: Int
    $number_of_customers: Int
    $power_plant_amount: Float!
    $power_plant_consumption_kW: Float!
    $power_plant_custo_disp_kW: Float
    $power_plant_inverter: Float
    $valor_conta: Float
  ) {
    createBillingTotal(
      billing: {
        competence: $competence
        power_plant_id: $power_plant_id
        current_balance: $current_balance
        last_balance: $last_balance
        data_leitura_anterior: $data_leitura_anterior
        data_leitura_atual: $data_leitura_atual
        data_leitura_proxima: $data_leitura_proxima
        dias_leitura: $dias_leitura
        number_of_customers: $number_of_customers
        power_plant_amount: $power_plant_amount
        power_plant_consumption_kW: $power_plant_consumption_kW
        power_plant_custo_disp_kW: $power_plant_custo_disp_kW
        power_plant_inverter: $power_plant_inverter
        valor_conta: $valor_conta
      }
    ) {
      competence
      power_plant_id
    }
  }
`;

//Cria fatura manualmente para o usuário
export const SET_BILLING = gql`
  mutation createBilling(
    $customer_id: String!
    $competence: String!
    $power_plant_id: String!
    $status: String!
    $amount: Float!
    $amount_kW: Float!
    $discount: Float!
    $total: Float!
    $total_invoice: Float!
    $total_utility_company: Float!
    $custo_disp: Float
    $balance: Float
    $due_date_utility: Date
    $consumer_units: [InputConsumerUnitBilling]!
  ) {
    createBilling(
      billing: {
        customer_id: $customer_id
        competence: $competence
        power_plant_id: $power_plant_id
        status: $status
        amount: $amount
        amount_kW: $amount_kW
        discount: $discount
        total: $total
        total_invoice: $total_invoice
        total_utility_company: $total_utility_company
        custo_disp: $custo_disp
        balance: $balance
        due_date_utility: $due_date_utility
        consumer_units: $consumer_units
      }
    ) {
      competence
      amount
      total
      discount
      status
    }
  }
`;
